module.exports = __webpack_public_path__ + "img/Tropical.b09af6a.jpg";